import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const AdkHourlyTable = ({ params, paramsObj, report, total,  onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} row={row} key={index} />));

    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} params={params} />
            <tbody>
                <TotalRow params={params} paramsObj={paramsObj} data={total}/>
                {rows}
            </tbody>
        </Table>
    )
};

export default AdkHourlyTable;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDaily/components/Table/index.js